import Resource from "./resource";
import {appContainer} from "../contexts/app";
import {List} from "immutable";
import {orderById} from "../lib";
import pluralize from "pluralize";

export default function BuildingRecordFactory(service) {
  const BuildingRecord = Resource(
    service,
    {
      account_id: "",
      facility_id: "",
      name: "",
      address: "",
      geo: {},
      floors_order: []
    },
    {
      floors() {
        const floors = appContainer.state.get("floors");
        if (!floors) {
          return List();
        }
        const filtered = floors
          .toList()
          // Filter the floors by those in the floors_order array
          .filter(function(floor) {
            return this.indexOf(floor._id) >= 0;
          }, this.floors_order)
          .map(floor => {
            //REDTAG:TJH - hack until I can do a data migration
            //to put facility_id on all floors;
            if (!floor.hacked) {
              floor.hacked = true;
              let path = floor.getPath();
              floor.getPath = () => `${this.facility_id}/${path}`;
            }
            return floor;
          });
        // Sort the infographics in order
        return orderById(filtered, this.floors_order);
      },

      getPath() {
        return `${this.facility_id}/${pluralize(appContainer.BuildingRecord.getTypeName(), 2)}/${this._id}`;
      },

      getNewChildPath() {
        return `${this.getPath()}/${pluralize(appContainer.FloorRecord.getTypeName(), 2)}`;
      },

      getTypeName() {
        return BuildingRecord.getTypeName();
      },

      getResource() {
        return BuildingRecord;
      }
    }
  );

  BuildingRecord.getTypeName = function() {
    return "building";
  };
  return BuildingRecord;
}



// WEBPACK FOOTER //
// ./src/feathers/building-record.js